import {
  getEditorString,
  setNodes,
  type TNodeEntry,
  unwrapNodes,
} from '@udecode/plate'
import type { BufferEditor } from '~publish/legacy/editor/BufferEditor/types.plate'
import { mentionContainsInvalidCharacter } from '../../autocomplete/transforms/mentionContainsInvalidCharacter'
import { LinkedInAnnotationInputElement } from '../nodes'

export const normalizeLinkedInAnnotationNode = (
  editor: BufferEditor,
  nodeEntry: TNodeEntry,
): boolean => {
  const [node, path] = nodeEntry

  if (LinkedInAnnotationInputElement.is(node)) {
    const { autocompleted, valid } = node
    const currentMentionText = getEditorString(editor, path)

    const triggerRemovedFromMention =
      !autocompleted &&
      !currentMentionText.startsWith(LinkedInAnnotationInputElement.trigger)

    if (triggerRemovedFromMention) {
      unwrapNodes(editor, {
        at: path,
        match: (n) => LinkedInAnnotationInputElement.is(n),
      })
      return true
    }

    if (
      !autocompleted &&
      !valid &&
      mentionContainsInvalidCharacter(
        editor,
        LinkedInAnnotationInputElement,
        nodeEntry,
      )
    ) {
      setNodes(
        editor,
        { valid: false },
        { at: path, match: (n) => LinkedInAnnotationInputElement.is(n) },
      )
      return true
    }
  }
  return false
}
